// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Typography, Avatar } from '@mui/material';
import { useSelector } from 'react-redux';
import { userReducerState } from 'redux/reducers/userReducer';
import { getFirstCharacter } from 'utils/firstCharacter';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

type Props = {
  isCollapse: boolean | undefined;
};

export default function NavbarAccount({ isCollapse }: Props) {
  const { name, isAdmin } = useSelector((state: { user: userReducerState }) => state.user);
  return (
    <Link underline="none" color="inherit">
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
          }),
        }}
      >
         <Avatar>{getFirstCharacter(name)}</Avatar>
        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0, 
            }),
          }}
        >
          <Typography variant="subtitle2" noWrap>
            {name}
          </Typography>
          <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
           {isAdmin ? 'Administrador' :  'Usuário'}
          </Typography>
        </Box>
      </RootStyle>
    </Link>
  );
}
